import React from 'react';
import { IconInfo, IconCalendar } from './PmIcons';

/* Estados reutilizables para las páginas de cuenta (dentro de .pm-scope). */

export const PmLoading = ({ message = 'Cargando…' }) => (
  <div className="acct-state" role="status" aria-live="polite">
    <span className="pm-spinner pm-spinner--lg" aria-hidden="true" />
    <p>{message}</p>
  </div>
);

export const PmError = ({ message, onRetry }) => (
  <div className="acct-state" role="alert">
    <span className="acct-state__icon"><IconInfo /></span>
    <h2>Algo salió mal</h2>
    <p>{message}</p>
    {onRetry && (
      <button type="button" className="btn btn--secondary btn--sm" onClick={onRetry}>
        Intentar de nuevo
      </button>
    )}
  </div>
);

export const PmEmpty = ({ title, text, action, icon: Icon = IconCalendar }) => (
  <div className="acct-state">
    <span className="acct-state__icon"><Icon /></span>
    <h2>{title}</h2>
    {text && <p>{text}</p>}
    {action}
  </div>
);

export const PmNotice = ({ variant = 'info', children, onClose }) => (
  <div className={`notice notice--${variant}`} role={variant === 'danger' ? 'alert' : 'status'}>
    <span>{children}</span>
    {onClose && (
      <button type="button" className="notice__close" aria-label="Cerrar" onClick={onClose}>×</button>
    )}
  </div>
);
